import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'multiSearchFilter',
})
export class MultiSearchFilterPipe implements PipeTransform {
  transform(values: any[], params: {[key:string]: string}): any[] {
    const keys =  Object.keys(params) || [];
    if (keys.length === 0 ||
      this.isEmpty(values)
    ) {
      return values;
    }

    const searchMap = {}
    return values.filter((value) => {
      let isValid = true;
      for (const key  of keys) {
        if(isValid && value[key] && params[key] && params[key]!=='All' && value[key] !== params[key]){
          return false;
        }
      }
      return isValid;
    });
  }
  private isEmpty(v: string | any[]) {
    return !v || v.length === 0;
  }
}
